<template>
  <IconBxHeart />
</template>
